module.exports = __webpack_public_path__ + "img/panneau_mobile.263dab8e.jpg";